import React, { useCallback, useMemo } from "react";
import { Button, Form } from "react-bootstrap";
import { X } from "react-feather";

const TextFilter = (props) => {
  const {
    column: { filterValue, setFilter },
  } = props;

  const filterPrefix = "$TEXT=";

  const parseFilterValue = useCallback(() => {
    var parseResult = null;

    if (
      filterValue &&
      typeof filterValue === "string" &&
      filterValue.startsWith(filterPrefix)
    ) {
      var rightSide = filterValue.substring(filterPrefix.length);

      parseResult = rightSide;
    }

    return parseResult;
  }, [filterValue]);

  const textValue = useMemo(() => parseFilterValue(), [parseFilterValue]);

  return (
    <div className="d-flex">
      <Form.Group className="flex-grow-1">
        <Form.Control
          type="text"
          value={textValue || ""}
          onChange={(e) => {
            setFilter(e.target.value ? filterPrefix + e.target.value : "");
          }}
        />
      </Form.Group>
      <Button
        variant=""
        className="p-0 m-0"
        onClick={() => {
          setFilter("");
        }}
      >
        <X />
      </Button>
    </div>
  );
};

export default TextFilter;
